import { gql } from "@apollo/client";

export const GET_ORGANISATION_AND_SITE = gql`
  query site($siteId: SiteID!) {
    site(siteId: $siteId) {
      id
      name
      company {
        id
        name
      }
    }
  }
`;
